function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.126 10.128A9 9 0 0017 5c-4.297 0-7.89 3.01-8.785 7.038A8 8 0 009 28h16a6 6 0 003.52-10.86 5.001 5.001 0 00-3.393-7.013zM17 7a7.002 7.002 0 00-6.938 6.061.996.996 0 01-.318.607A.998.998 0 019 14a6 6 0 000 12h16a4 4 0 001.785-7.58.999.999 0 01-.432-1.559 3 3 0 00-2.012-4.842 1 1 0 01-.841-.624A7.003 7.003 0 0017 7z",
  fill: "currentColor"
})));